import {
  Button,
  ButtonColor,
  ButtonSize,
  majorStatusList,
  SearchControl,
  StatusMetricCardList,
  useStatusCount
} from "@quortex/front-common"
import type { FC } from "react"
import {
  endpointMinorStatusList,
  statusFilterOptionList
} from "@/App/play/App/Main/Pool/endpoints/helpers"
import StatusFilter from "@/App/play/components/wired/filters/StatusFilter"
import { filterWidth } from "@/App/play/helpers/filters"

type Props = {
  ottEndpoints: api.ott.OttEndpoint[]
  onStatusFilterChange: (value: string[]) => void
  isSearchOrFilterActive: boolean
  clearFilters: () => void
  rowStatusCount: Record<string, number>
}

const OttEndpointFiltersSection: FC<Props> = ({
  ottEndpoints,
  onStatusFilterChange,
  isSearchOrFilterActive,
  clearFilters,
  rowStatusCount
}) => {
  const endpointMetrics = useStatusCount(ottEndpoints)

  return (
    <>
      <StatusMetricCardList
        majorStatusList={majorStatusList}
        minorStatusList={endpointMinorStatusList}
        statusCompleteList={statusFilterOptionList}
        statusCount={endpointMetrics}
      />

      <div className="mt-lg flex flex-wrap items-start gap-sm">
        <SearchControl className={filterWidth} width="small" />

        <StatusFilter
          statusCount={rowStatusCount}
          statusList={statusFilterOptionList}
          onChange={onStatusFilterChange}
        />

        {isSearchOrFilterActive && (
          <Button
            className="mt-2xs"
            color={ButtonColor.TERTIARY}
            size={ButtonSize.MEDIUM}
            type="button"
            onClick={clearFilters}
          >
            Clear all
          </Button>
        )}
      </div>
    </>
  )
}

export default OttEndpointFiltersSection
